<template>
  <!-- Navbar Start -->
  <nav
    class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0 px-4 px-lg-5"
  >
    <a href="/" class="navbar-brand d-flex align-items-center">
      <h2 class="m-0 text-primary">
        <img
          class="img-fluid me-2"
          src="img/logo-dalto.jpeg"
          alt=""
          style="width: 45px"
        />Dalto Investments
      </h2>
    </a>
    <button
      type="button"
      class="navbar-toggler"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <div class="navbar-nav ms-auto py-4 py-lg-0">
        <a href="/" class="nav-item nav-link active">Home</a>
        <a href="/about" class="nav-item nav-link">About</a>
        <a href="/service" class="nav-item nav-link">Service</a>
        <a href="/contact" class="nav-item nav-link">Contact</a>
      </div>
      <div class="h-100 d-lg-inline-flex align-items-center d-none">
        <a
          class="btn btn-primary rounded-pill me-2"
          href="https://direct.daltoinvestments.com/auth-sign-in"
          target="_blank"
          >Sign In</a
        >
        <a
          class="btn btn-primary rounded-pill me-0"
          href="https://direct.daltoinvestments.com/auth-sign-up"
          target="_blank"
          >Sign Up</a
        >
      </div>
    </div>
  </nav>
  <!-- Navbar End -->

  <!-- Header Start -->
  <div class="container-fluid hero-header bg-light py-5 mb-5">
    <div class="container py-5">
      <div class="row g-5 align-items-center">
        <div class="col-lg-6">
          <h1 class="display-4 mb-3 animated slideInDown">
            Grow Your Wealth with Dalto Investments
          </h1>
          <p class="animated slideInDown">
            Join Dalto Investments and let your money work for you. We offer
            expert Tradingcurrency trading and Investments management,
            delivering consistent returns on your Investments through our
            weekly, monthly, or quarterly plans.
          </p>
          <a href="https://direct.daltoinvestments.com" class="btn btn-primary py-3 px-4 animated slideInDown"
            >Start Investing</a
          >
        </div>
        <div class="col-lg-6 animated fadeIn">
          <img
            class="img-fluid animated pulse infinite"
            style="animation-duration: 3s"
            src="img/golda-5.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Header End -->

  <!-- About Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div class="row g-5 align-items-center">
        <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
          <img
            class="img-fluid"
            src="img/gold_trading_hours.width-648.png"
            alt=""
          />
        </div>
        <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="h-100">
            <h1 class="display-6">About Us</h1>
            <p class="text-primary fs-5 mb-4">
              Your Trusted Partner in Trading Investments
            </p>
            <p>
              At Dalto Investments, we specialize in Tradingcurrency trading and
              Investments management. Our team of experienced traders works
              tirelessly to maximize returns for our investors through strategic
              Trading Investments.
            </p>
            <p class="mb-4">
              We welcome investors to entrust us with their funds, which we use
              to trade in the dynamic Trading market. With flexible return
              periods—weekly, monthly, or quarterly—we ensure your Investments
              grows according to your goals.
            </p>
            <div class="d-flex align-items-center mb-2">
              <i
                class="fa fa-check bg-light text-primary btn-sm-square rounded-circle me-3 fw-bold"
              ></i>
              <span>Proven track record in Trading trading</span>
            </div>
            <div class="d-flex align-items-center mb-2">
              <i
                class="fa fa-check bg-light text-primary btn-sm-square rounded-circle me-3 fw-bold"
              ></i>
              <span>Flexible Investments plans</span>
            </div>
            <div class="d-flex align-items-center mb-4">
              <i
                class="fa fa-check bg-light text-primary btn-sm-square rounded-circle me-3 fw-bold"
              ></i>
              <span>Transparent return schedules</span>
            </div>
            <a class="btn btn-primary py-3 px-4" href="">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- About End -->
  <!-- Facts Start -->
  <!-- <div class="container-xxl bg-light py-5 my-5">
    <div class="container py-5">
      <div class="row g-5">
        <div
          class="col-lg-4 col-md-6 text-center wow fadeIn"
          data-wow-delay="0.1s"
        >
          <img class="img-fluid mb-4" src="img/icon-9.png" alt="" />
          <h1 class="display-4" data-toggle="counter-up">123456</h1>
          <p class="fs-5 text-primary mb-0">Today Transactions</p>
        </div>
        <div
          class="col-lg-4 col-md-6 text-center wow fadeIn"
          data-wow-delay="0.3s"
        >
          <img class="img-fluid mb-4" src="img/icon-10.png" alt="" />
          <h1 class="display-4" data-toggle="counter-up">123456</h1>
          <p class="fs-5 text-primary mb-0">Monthly Transactions</p>
        </div>
        <div
          class="col-lg-4 col-md-6 text-center wow fadeIn"
          data-wow-delay="0.5s"
        >
          <img class="img-fluid mb-4" src="img/icon-2.png" alt="" />
          <h1 class="display-4" data-toggle="counter-up">123456</h1>
          <p class="fs-5 text-primary mb-0">Total Transactions</p>
        </div>
      </div>
    </div>
  </div> -->
  <!-- Facts End -->

  <!-- Features Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div
        class="text-center mx-auto wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <h1 class="display-6">Why Choose Us!</h1>
        <p class="text-primary fs-5 mb-5">Excellence in Trading Investments</p>
      </div>
      <div class="row g-5">
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="d-flex align-items-start">
            <img class="img-fluid flex-shrink-0" src="img/icon-7.png" alt="" />
            <div class="ps-4">
              <h5 class="mb-3">Simple Onboarding</h5>
              <span
                >Get started with your Investments journey in just a few steps.
                Sign up, choose your plan, and watch your wealth grow.</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
          <div class="d-flex align-items-start">
            <img class="img-fluid flex-shrink-0" src="img/icon-6.png" alt="" />
            <div class="ps-4">
              <h5 class="mb-3">Secure Trading</h5>
              <span
                >Your Investmentss are protected with state-of-the-art security
                measures, ensuring peace of mind.</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="d-flex align-items-start">
            <img class="img-fluid flex-shrink-0" src="img/icon-5.png" alt="" />
            <div class="ps-4">
              <h5 class="mb-3">Flexible Returns</h5>
              <span
                >Choose your preferred return schedule—weekly, monthly, or
                quarterly—to suit your financial needs.</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="d-flex align-items-start">
            <img class="img-fluid flex-shrink-0" src="img/icon-4.png" alt="" />
            <div class="ps-4">
              <h5 class="mb-3">Safe Asset Management</h5>
              <span
                >We securely manage your funds, leveraging our expertise to
                optimize returns in the Trading market.</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
          <div class="d-flex align-items-start">
            <img class="img-fluid flex-shrink-0" src="img/icon-3.png" alt="" />
            <div class="ps-4">
              <h5 class="mb-3">Expert Trading Team</h5>
              <span
                >Our skilled traders use advanced strategies to ensure
                consistent growth for your Investmentss.</span
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="d-flex align-items-start">
            <img class="img-fluid flex-shrink-0" src="img/icon-8.png" alt="" />
            <div class="ps-4">
              <h5 class="mb-3">24/7 Support</h5>
              <span
                >Our dedicated team is available around the clock to assist you
                with any questions or concerns.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Features End -->

  <!-- Service Start -->
  <div class="container-xxl bg-light py-5 my-5">
    <div class="container py-5">
      <div
        class="text-center mx-auto wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <h1 class="display-6">Services</h1>
        <p class="text-primary fs-5 mb-5">
          Maximize Your Returns with Dalto Investments
        </p>
      </div>
      <div class="row g-4">
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="service-item bg-white p-5">
            <img class="img-fluid mb-4" src="img/icon-7.png" alt="" />
            <h5 class="mb-3">Trading Portfolio Management</h5>
            <p>
              We manage your Trading Investmentss with precision, ensuring
              optimal growth based on market trends.
            </p>
            <a href="">Read More <i class="fa fa-arrow-right ms-2"></i></a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
          <div class="service-item bg-white p-5">
            <img class="img-fluid mb-4" src="img/icon-3.png" alt="" />
            <h5 class="mb-3">Currency Trading</h5>
            <p>
              Our experts trade your funds in the Trading market, delivering
              returns on your chosen schedule.
            </p>
            <a href="">Read More <i class="fa fa-arrow-right ms-2"></i></a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="service-item bg-white p-5">
            <img class="img-fluid mb-4" src="img/icon-9.png" alt="" />
            <h5 class="mb-3">Investments Plans</h5>
            <p>
              Choose from our tailored plans—weekly, monthly, or quarterly—to
              enjoy steady returns on your Investments.
            </p>
            <a href="">Read More <i class="fa fa-arrow-right ms-2"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Service End -->

  <!-- FAQs Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div
        class="text-center mx-auto wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <h1 class="display-6">FAQs</h1>
        <p class="text-primary fs-5 mb-5">Frequently Asked Questions</p>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="accordion" id="accordionExample">
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.1s">
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  How do I start investing with Dalto Investments?
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Simply sign up on our platform, choose your Investments plan
                  (weekly, monthly, or quarterly), deposit your funds, and our
                  team will start trading on your behalf.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.2s">
              <h2 class="accordion-header" id="headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  How often will I receive returns?
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  You can choose your preferred return schedule—weekly, monthly,
                  or quarterly—based on the Investments plan you select.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.3s">
              <h2 class="accordion-header" id="headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Is my Investments secure?
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Yes, we use advanced security protocols to protect your funds
                  and ensure safe trading practices in the Trading market.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.4s">
              <h2 class="accordion-header" id="headingFour">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="true"
                  aria-controls="collapseFour"
                >
                  What Tradingcurrencies do you trade?
                </button>
              </h2>
              <div
                id="collapseFour"
                class="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Our expert traders work with a diverse range of
                  Tradingcurrencies, including Bitcoin, Ethereum, and other
                  high-potential altcoins, to maximize your returns.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.5s">
              <h2 class="accordion-header" id="headingFive">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  Can I withdraw my funds anytime?
                </button>
              </h2>
              <div
                id="collapseFive"
                class="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Withdrawals are available according to your Investments plan’s
                  terms. Contact our support team for assistance with the
                  process.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.6s">
              <h2 class="accordion-header" id="headingSix">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  What is the minimum Investments amount?
                </button>
              </h2>
              <div
                id="collapseSix"
                class="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Our minimum Investments starts at an affordable amount to
                  accommodate investors of all levels. Check our plans page for
                  details.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.7s">
              <h2 class="accordion-header" id="headingSeven">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="false"
                  aria-controls="collapseSeven"
                >
                  How can I track my Investments?
                </button>
              </h2>
              <div
                id="collapseSeven"
                class="accordion-collapse collapse"
                aria-labelledby="headingSeven"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  We provide a user-friendly dashboard where you can monitor
                  your Investments growth and returns in real-time.
                </div>
              </div>
            </div>
            <div class="accordion-item wow fadeInUp" data-wow-delay="0.8s">
              <h2 class="accordion-header" id="headingEight">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEight"
                  aria-expanded="false"
                  aria-controls="collapseEight"
                >
                  What if I have more questions?
                </button>
              </h2>
              <div
                id="collapseEight"
                class="accordion-collapse collapse"
                aria-labelledby="headingEight"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  Our 24/7 support team is always ready to assist you. Reach out
                  via email or live chat for personalized help.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FAQs End -->

  <!-- Footer Start -->
  <div
    class="container-fluid bg-light footer mt-5 pt-5 wow fadeIn"
    data-wow-delay="0.1s"
  >
    <div class="container py-5">
      <div class="row g-5">
        <div class="col-md-6">
          <h1 class="text-primary mb-4">
            <img
              class="img-fluid me-2"
              src="img/logo-dalto.jpeg"
              alt=""
              style="width: 45px"
            />Dalto Investments
          </h1>
          <span>
            Dalto Investments is your gateway to financial growth through
            Tradingcurrency. We accept Investmentss from individuals and
            Investmentses, expertly trading your funds in the Trading market to
            deliver consistent returns on a weekly, monthly, or quarterly basis.
          </span>
        </div>
        <div class="col-md-6">
          <h5 class="mb-4">Newsletter</h5>
          <p>
            Stay updated with the latest Trading Investments opportunities and
            market insights.
          </p>
          <div class="position-relative">
            <input
              class="form-control bg-transparent w-100 py-3 ps-4 pe-5"
              type="text"
              placeholder="Your email"
            />
            <button
              type="button"
              class="btn btn-primary py-2 px-3 position-absolute top-0 end-0 mt-2 me-2"
            >
              SignUp
            </button>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <h5 class="mb-4">Get In Touch</h5>
          <p><i class="fa fa-envelope me-3"></i>daltoInvestments@gmail.com</p>
        </div>
        <div class="col-lg-3 col-md-6">
          <h5 class="mb-4">Quick Links</h5>
          <a class="btn btn-link" href="">About Us</a>
          <a class="btn btn-link" href="">Contact Us</a>
          <a class="btn btn-link" href="">Our Services</a>
          <a class="btn btn-link" href="">Terms & Condition</a>
        </div>
        <div class="col-lg-3 col-md-6">
          <h5 class="mb-4">Create Account Here and Invest With Us</h5>
          <div class="h-100 d-lg-inline-flex align-items-center d-none">
            <a
              class="btn btn-primary rounded-pill me-2"
              href="https://direct.daltoinvestments.com/auth-sign-in"
              >Sign In</a
            >
            <a
              class="btn btn-primary rounded-pill me-0"
              href="https://https://direct.daltoinvestments.com/auth-sign-up"
              >Sign Up</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
            © <a href="#">Dalto Investments</a>, All Right Reserved.
          </div>
          <!-- <div class="col-md-6 text-center text-md-end">
            Designed By <a href="https://tambagroup.xyz">Tamba Group</a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- Footer End -->

  <!-- Back to Top -->
  <a
    href="#"
    class="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"
    ><i class="bi bi-arrow-up"></i
  ></a>
</template>
